import AzureADService from "./azureADService";
import GoogleAuthService from "./googleAuthService";
import Store from "../store";
import { EndPoint } from "../appConfig";
import request from "superagent";
import moment from "moment";
import Cache from "../cache";

const cache = new Cache();
var AccountService = {};
const store = new Store();
const getValue = function(values, key) {
  for (var i = 0, length = values.endPoinInfo.length; i < length; i++) {
    var value = values.endPoinInfo[i];
    if (value.key == key) {
      return value.value;
    }
  }
};
/**
 * accountのログイン情報(ログイン先のテナントなど)を取得しsuccessを呼び出します。
 *
 * @param {String} account
 */
AccountService.getLoginInfo = function(account) {
  return new Promise(function(resolve, reject) {
    if (!account) {
      reject(account);
    }
    request
      .get(EndPoint.Login)
      .query({ account })
      .set("accept", "json")
      .end((err, res) => {
        err ? reject(res) : resolve(res.text ? JSON.parse(res.text) : res.text);
      });
  });
};
AccountService.handleWindowCallback = function() {
  if (store.loginInfo && store.loginInfo.type === "O365")
    return AzureADService.handleWindowCallback(
      getValue(store.loginInfo, "clientId")
    );
};
AccountService.isLogedin = function() {
  var tokenLimit = moment(new Date())
    .add(-5, "m")
    .toDate();
  return store.token && new Date(store.token.expiresOn) > tokenLimit;
};
AccountService.logout = function(success) {
  store.token = null;
  cache.remove();
  if (!store.loginInfo) {
    success();
    return;
  }
  if (store.loginInfo && store.loginInfo.type === "O365") {
    store.account = "";
    var clientId = getValue(store.loginInfo, "clientId");
    AzureADService.logout(clientId);
  } else if (store.loginInfo.type === "GSuite") {
    store.loginInfo = null;
    GoogleAuthService.logout(success);
  } else {
    store.account = "";
    store.loginInfo = null;
    success();
  }
};
AccountService.login = function(success, error) {
  if (!store.loginInfo) {
    error();
    return;
  }
  if (store.loginInfo.type === "O365") {
    AzureADService.authenticate(
      getValue(store.loginInfo, "authority"),
      getValue(store.loginInfo, "resource"),
      getValue(store.loginInfo, "clientId"),
      getValue(store.loginInfo, "redirectUri"),
      store.account,
      function(res) {
        store.account = res.upn;
        store.token = {
          accessToken: res.accessToken,
          expiresOn: res.expiresOn
        };
        success();
      },
      function() {
        store.loginInfo = null;
        error();
      }
    );
  } else if (store.loginInfo.type === "GSuite") {
    GoogleAuthService.login(
      res => {
        // Googleは全く別のテナントでログインできちゃうので、入力値と違うユーザーではログインできなくする。
        if (store.account.trim().toUpperCase() != res.email.toUpperCase()) {
          GoogleAuthService.logout();
          AccountService.login(success, error);
          return;
        }
        store.account = res.email;
        var tokenObj = {
          accessToken: res.idToken,
          expiresOn: res.expires
            ? res.expires * 1000
            : moment(new Date())
                .add(30, "m")
                .toDate()
                .getTime()
        };
        store.token = tokenObj;
        success();
      },
      () => {
        store.loginInfo = null;
        error();
      }
    );
    GoogleAuthService.init(getValue(store.loginInfo, "clientId"));
  } else {
    error();
  }
};
export default AccountService;
